import React, { memo, useContext, useEffect } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import {
  getChatRooms,
  getHistory,
  getIsUserAdmin,
  getOthersChats,
  groupByKey,
  useAuth,
  useLocalStorage
} from "../../core";
import { BotContext } from "../context/BotContext";
import { BotContainer } from "../pages/bot/BotContainer";

const Container = memo(() => {
  const { user, signout } = useAuth();

  const {
    setRooms,
    setSelectedRoom,
    selectedRoom,
    setChats,
    chatsArray,
    setChatsArray,
    setShowWelcome,
    setChatStateMode,
    page,
    setAskedQuestions,
    historyUser,
    setIsAdmin,
    setIsHistoryReady
  } = useContext(BotContext);
  const [room] = useLocalStorage("room");
  const history = useHistory();
  useEffect(() => {
    if (user && user?.accessToken && user?.loggedIn) {
      mutateChatRooms();
      // mutateIsAdmin();
    } else {
      signout(history);
    }
  }, [user]);

  const { mutate: mutateChatRooms, error: chatroomsError } = useMutation(
    ["getChatRooms"],
    async () => {
      const { data } = await getChatRooms();
      const rooms = data?.data.rooms;
      // setRooms(data?.data.rooms);
      setRooms(data?.data.rooms);
      if (room && rooms.includes(room)) {
        setSelectedRoom(room);
      } else {
        setSelectedRoom(data?.data.rooms[0]);
        // setRoom(data[0]);
      }

      return data;
    },
    {
      mutationKey: "getChatRooms",
      onSuccess() {
        // if (process.env.REACT_APP_URL_TOKEN === "false") {
        mutateIsAdmin();
        // }
      },
    }
  );
  const { mutate: mutateIsAdmin } = useMutation("getIsUserAdmin", async () => {
    const { data } = await getIsUserAdmin();
    setIsAdmin(data.data.isAdmin !== "False");
  });
  const { mutate: refetchOthersChats } = useMutation(
    ["getOthersChats"],
    async (p) => {
      if (!!selectedRoom?.name && historyUser) {
        const { data } = await getOthersChats({
          chat_room_name: selectedRoom?.name,
          target_username: historyUser.username,
          page: p,
        });
        if (p === 1) {
          setChatsArray(data.data.chats.reverse());
          handleSuggestionQuestions(data.data.chats);
        } else {
          setChatsArray([...data.data.chats.reverse(), ...chatsArray]);
        }

        // setChats(groupByKey(data.reverse(), "question_date"));
        return data;
      }
    }
  );
  // const {} = useMutation(async () => {
  //   const { data } = await getLastUsers();
  // });

  const { error: chatsError, mutate: refetchChats } = useMutation(
    ["getChatHistory", historyUser],
    async (p) => {
      if (!!selectedRoom?.name && !historyUser) {
        const { data } = await getHistory(selectedRoom?.name, p);
        return data;
      }
    },
    {
      onSuccess({ data: { chats, show_welcome_msg, state } }, p) {
        setIsHistoryReady(true)
        if (p === 1) {
          setShowWelcome(show_welcome_msg)
          setChatsArray(chats.reverse());
          handleSuggestionQuestions(chats);
        } else {
          setChatsArray([...chats.reverse(), ...chatsArray]);
        }
      },
    }
  );

  const handleSuggestionQuestions = (chats) => {
    const list = [];
    const chatswithquestion = chats.filter(chat => chat?.question)
    chatswithquestion.map(({ label_question, question }, index) => {
      list.push({ label_question, question });
    });
    setAskedQuestions([
      {
        question: "",
        label_question: "",
      },
      ...list.reverse(),
    ]);
  };
  useEffect(() => {
    if (page > 1 && !historyUser) {
      refetchChats(page);
    } else if (page > 1 && historyUser) {
      refetchOthersChats(page);
    }
  }, [page]);
  useEffect(() => {
    if (chatsArray?.length > 0) {
      setChats(groupByKey(chatsArray, "createdAt"));
    }
  }, [chatsArray]);
  useEffect(() => {
    // setPage(1);

    if (selectedRoom && !historyUser) {
      refetchChats(1);
    } else if (selectedRoom && historyUser) {
      refetchOthersChats(1);
    }
  }, [selectedRoom, historyUser]);

  const error = chatroomsError || chatsError;
  return <BotContainer {...{ error }} />;
});

export { Container };
